export var SCRIPT_TAG_NOT_FOUND = {
    file: "file.js",
    fileNoExt: "file",
    fullPath: "http://location.invalid/no/matching/script/tag/file.js?query",
    path: "http://location.invalid/no/matching/script/tag/",
    query: "?query",
};
export var SCRIPT_SRC_IS_NOT_HTTP = {
    file: "file.js",
    fileNoExt: "file",
    fullPath: "http://location.invalid/src/is/not/http/file.js?query",
    path: "http://location.invalid/src/is/not/http/",
    query: "?query",
};
/**
 * Try to return the url of the script tag that loaded the current script.
 */
export function scriptLocation(widgetTag) {
    var scriptTag = document.querySelector("script[src*=\"" + widgetTag + "\"]");
    if (!scriptTag) {
        return SCRIPT_TAG_NOT_FOUND;
    }
    var srcAttr = scriptTag.src;
    var pathParts = srcAttr.match(/((http[s]?:\/\/.+\/)([^\/]+\.[a-zA-Z]+)(\?[\w\d]+)?)/);
    if (pathParts) {
        var parts = pathParts[3].split(".");
        parts.length = parts.length !== 1 ? parts.length - 1 : 1;
        var fileNoExt = parts.join(".");
        return {
            file: pathParts[3],
            fileNoExt: fileNoExt,
            fullPath: pathParts[1],
            path: pathParts[2],
            query: pathParts[4] || "",
        };
    }
    else {
        return SCRIPT_SRC_IS_NOT_HTTP;
    }
}
